<script lang="ts">
  import { humanizeCategory } from '$lib/utils/blogClient';
  import Icon from '../Icon.svelte';

  export let post: any;

  export let user: string;

  // The category is retrieved differently depending on whether the post comes
  // from the "get all posts" API or from the "related posts".
  let category: string = post.categories
    ? humanizeCategory(post.categories[0])
    : post._embedded['wp:term'][0][0].name;

  function sliceText(text: any, start: number, end: number) {
    const contractedText = text.split(' ').slice(start, end);
    return contractedText.join(' ');
  }
</script>

<div class="mb-3">
  {#if user}
    <p class="tags mb-0">
      <span class="me-2">
        <Icon icon="user" additionalClasses="me-1"></Icon>
        {user}
      </span>
    </p>
  {/if}

  {#if post && category}
    <p class="tags">
      <span class="me-2">
        <Icon icon="tags" additionalClasses="me-1"></Icon>
        {category}
      </span>
    </p>
  {/if}
</div>

{#if !post.excerpt.protected}
  <div class="post-content">
    <p class="mb-8">
      {@html sliceText(post.excerpt.rendered, 0, 30) + ' [...]'}
    </p>
  </div>
{/if}

{#if post.excerpt.protected}
  <div class="post-content">
    <p class="mb-8">The post will be published soon</p>
  </div>
{/if}

<style>
  .tags {
    font-size: 0.8em;
    color: var(--grey-50);
    display: inline-block;
  }

  .post-content {
    font-size: 1em;
  }
</style>
